'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createPromise = createPromise;
exports.loadScripts = loadScripts;

exports.default = function (scripts) {
  return function (WrappedComponent) {
    var LoadScript = function (_React$Component) {
      _inherits(LoadScript, _React$Component);

      function LoadScript(props) {
        _classCallCheck(this, LoadScript);

        var _this = _possibleConstructorReturn(this, (LoadScript.__proto__ || Object.getPrototypeOf(LoadScript)).call(this, props));

        _this.state = {
          isScriptLoadSucceed: false,
          isScriptLoaded: false
        };
        return _this;
      }

      _createClass(LoadScript, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          loadScripts(scripts).then(function () {
            _this2.setState({
              isScriptLoaded: true,
              isScriptLoadSucceed: true
            });
          }).catch(function (err) {
            _this2.setState({
              isScriptLoaded: true,
              isScriptLoadSucceed: false
            });
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              forwardedRef = _props.forwardedRef,
              rest = _objectWithoutProperties(_props, ['forwardedRef']);

          return _react2.default.createElement(WrappedComponent, _extends({
            ref: forwardedRef,
            isScriptLoaded: this.state.isScriptLoaded,
            isScriptLoadSucceed: this.state.isScriptLoadSucceed
          }, rest));
        }
      }]);

      return LoadScript;
    }(_react2.default.Component);

    LoadScript.displayName = 'AsyncLoadScripts';

    return _react2.default.forwardRef(function (props, ref) {
      return _react2.default.createElement(LoadScript, _extends({}, props, { forwardedRef: ref }));
    });
  };
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _asyncscript = require('./asyncscript.js');

var _asyncscript2 = _interopRequireDefault(_asyncscript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates a single promise
 * @params {string} url
 */
function createPromise(url) {
  return new Promise(function (resolve, reject) {
    (0, _asyncscript2.default)(document, url, function (err) {
      return err ? reject(err) : resolve(url);
    });
  });
}

/**
 * Sequentially execute promise
 * @params {Array} scripts
 */
function loadScripts(scripts) {
  return Promise.all(scripts.map(createPromise));
}

/**
 * Higher order component to load array of script tags
 * @params {Array} scripts
 */